export const MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024
export const MAX_ATTACHMENTS = 10

export interface AttachmentRef {
  token: string
  fileName: string
  size: number
  contentType: string
}

export interface AttachmentUploadError extends Error {
  percent: number
  aborted: boolean
}

export interface AttachmentUploader {
  upload: (
    file: File,
    onProgress: (percent: number) => void,
    signal: AbortSignal
  ) => Promise<AttachmentRef>
  remove: (ref: AttachmentRef) => Promise<void>
}

type AttachmentStatus = 'uploading' | 'uploaded' | 'failed' | 'rejected'

export interface AttachmentItem {
  id: string
  file: File
  fileName: string
  size: number
  status: AttachmentStatus
  percent: number
  error: string | null
  ref: AttachmentRef | null
}

export interface AttachmentCallbacks {
  onAdded?: (item: { size: number; contentType: string }) => void
  onUploadFailed?: (failure: { reason: string; percent: number }) => void
  onRemoved?: () => void
}
